import type { TFunction } from 'i18next';

/** Фильтр «Активные / Архив / Все» справочников. */
export function statusOptions(t: TFunction) {
  return [
    { label: t('filters.active'), value: 'active' },
    { label: t('filters.archive'), value: 'inactive' },
    { label: t('filters.all'), value: 'all' },
  ];
}
